var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',[_vm._v("You can drag desks around to assign them a new location. Click a desk for additional options.")])}
var staticRenderFns = []

export { render, staticRenderFns }